export const SET_DRAWER_OPEN = 'module_kbi_ehs/state/ui/SET_DRAWER_OPEN';
export const SET_SMALL_DEVICE = 'module_kbi_ehs/state/ui/SET_SMALL_DEVICE';
